import http, { handleApiResponse, checkResponse, handleApiResponseWithSuccess } from "@/services/http"

import ApiResponse from "@/models/ApiResponse"
import CashFlowRiportGroup from "../models/CashFlowRiportGroup";
import CashFlowRiportGroupItem from "../models/CashFlowRiportGroupItem";
import CashFlowRiportHead from "../models/CashFlowRiportHead";
import AccountingYear from "../models/AccountingYear";
import GeneralLedgerRiportRowItem from "../models/GeneralLedgerRiportRowItem";
import GeneralLedgerRiportRowTransactionAmount from "../models/GeneralLedgerRiportRowTransactionAmount";

export default class CashFlowApi {

  //---------- Riport ----------//

  static async getCashFlowRiport(cashFlowRiportId: number): Promise<CashFlowRiportHead> {
    return await http.get<ApiResponse<CashFlowRiportHead>>(`cashflow-riport/riport/${cashFlowRiportId}`)
      .then(handleApiResponse);
  }
  
  static createCashFlowRiport(generalLedgerRiportId: number, newAccountingYear: number, isEmpty?: boolean, previousCashFlowRiportId?: number): Promise<number> {
    return http.post<ApiResponse<number>>(`cashflow-riport/create/${generalLedgerRiportId}/${newAccountingYear}/${isEmpty}/${previousCashFlowRiportId}`)
      .then(handleApiResponse);
  }

  static updateCashFlowRiport(cashFlowRiportHead: CashFlowRiportHead, cashFlowRiportGroups: CashFlowRiportGroup[], cashFlowRiportGroupItems: CashFlowRiportGroupItem[], generalLedgerRiportRowItems: GeneralLedgerRiportRowItem[]): Promise<void> {
    return http.post<ApiResponse<void>>(`cashflow-riport/update`, { cashFlowRiportHead: cashFlowRiportHead, cashFlowRiportGroups: cashFlowRiportGroups, cashFlowRiportGroupItems: cashFlowRiportGroupItems, generalLedgerRiportRowItems: generalLedgerRiportRowItems })
      .then(handleApiResponseWithSuccess);
  }

  static removeCashFlowRiport(cashFlowRiportId: number): Promise<void> {
    return http.delete<ApiResponse<void>>(`cashflow-riport/remove/${cashFlowRiportId}`)
      .then(handleApiResponseWithSuccess);
  }

  static getCashFlowRiportChain(generalLedgerRiportId: number): Promise<CashFlowRiportHead[]> {
    return http.get<ApiResponse<CashFlowRiportHead[]>>(`cashflow-riport/riport/${generalLedgerRiportId}/chain`)
      .then(handleApiResponse);
  }

  //---------- Riport csoportok ----------//

  static async getCashFlowRiportGroups(cashFlowRiportId: number): Promise<CashFlowRiportGroup[]> {
    return await http.get<ApiResponse<CashFlowRiportGroup[]>>(`cashflow-riport/${cashFlowRiportId}/groups`)
      .then(handleApiResponse);
  }

  //---------- Riport csoport tételei ----------//

  static getCashFlowRiportGroupItems(cashFlowGroupIds: number[]): Promise<CashFlowRiportGroupItem[]> {
    return http.post<ApiResponse<CashFlowRiportGroupItem[]>>(`cashflow-riport/items`, cashFlowGroupIds)
      .then(handleApiResponse);
  }

  //---------- Sablon sor tételek ---------//
  
  static getGeneralLedgerRiportRowItems(generalLedgerReportRows: number[]): Promise<GeneralLedgerRiportRowItem[]> {
    return http.post<ApiResponse<GeneralLedgerRiportRowItem[]>>(`generalledger-riport/rows/items`, generalLedgerReportRows)
      .then(handleApiResponse);
  }

  //---------- Sablon tényadatok ---------//

  static getGeneralLedgerRiportRowsTransAmounts(year: number, generalLedgerRiportRowItems: GeneralLedgerRiportRowItem[]): Promise<GeneralLedgerRiportRowTransactionAmount[]> {
    return http.post<ApiResponse<GeneralLedgerRiportRowTransactionAmount[]>>(`generalledger-riport/rows/${year}/transactionamounts`, generalLedgerRiportRowItems)
      .then(handleApiResponse);
  }
  
  //----------

  static getAccountingYearsFromNow(): Promise<AccountingYear[]> {
    return http.get<ApiResponse<AccountingYear[]>>(`cashflow-riport/supplycomponents/accyearsfromnow`)
      .then(handleApiResponse);
  }
}